export const P0003607AsservissementVolet = [
  { ref: 0, label: 'P0003607.installation.alimentation' },
  { ref: 1, label: 'P0003607.installation.sel' },
];
